import React from 'react'
import { compose } from 'lodash/fp'
import { IFormElementProps } from '../../FormElement/FormInput'
import withReduxForm from '../../withReduxForm'
import withRedux from './withRedux'
import { MainPrice } from './MainPrice'

const ReduxField: React.ComponentType<IFormElementProps> = compose(
  withReduxForm,
  withRedux,
)(MainPrice)

export default ReduxField
export { MainPrice }
